export default (axios) => ({
  async list(utoken, termType) {
    try {
      const response = await axios({
        method: 'GET',
        url: 'terms/user',
        headers: { utoken },
        params: { termType }
      });
      return response.data;
    } catch (error) {
      console.log('TermsAccepted -> ', error);
    }
  },
  async accept(utoken, termType) {
    try {
      const response = await axios({
        method: 'POST',
        url: 'terms/user/accept',
        headers: { utoken },
        params: { termType }
      });
      return response.data;
    } catch (error) {
      console.log('TermsAccepted -> ', error);
    }
  }
});
